import {gsap} from "../LibrariesImport";

export default class BlockServicesList {

    static init() {
        const blocks = document.querySelectorAll(".block-services-list");

        if (blocks.length < 1) {
            return;
        }

        blocks.forEach(block => {
            this.initBlockAnimations(block);
        });
    }

    static initBlockAnimations(block) {
        const services = block.querySelector(".nav-services");
        const thumbnails = services.querySelector(".thumbnails");

        if (thumbnails) {
            const moveConfig = {
                duration: 0.4,
                ease: "power2.out"
            };
            const fadeConfig = {
                duration: 0.3,
                ease: "power2.out"
            };

            // Création des fonctions quickTo uniquement pour le mouvement
            const moveX = gsap.quickTo(thumbnails, "left", moveConfig);
            const moveY = gsap.quickTo(thumbnails, "top", moveConfig);
            const rotate = gsap.quickTo(thumbnails, "rotation", moveConfig);

            // État initial
            gsap.set(thumbnails, {
                scale: 0.5,
                opacity: 0
            });

            // Gestion des vignettes actives
            const serviceItems = services.querySelectorAll('li');
            const thumbs = thumbnails.querySelectorAll('.thumb');

            serviceItems.forEach(item => {
                item.addEventListener('mouseenter', () => {
                    const index = item.dataset.item;
                    thumbs.forEach(thumb => thumb.classList.remove('active'));
                    thumbnails.querySelector(`.thumb[data-item="${index}"]`)?.classList.add('active');

                });
            });



            services.addEventListener("mouseenter", (e) => {
                const blockOffset = services.getBoundingClientRect();

                gsap.set(thumbnails, {
                    left: e.clientX - blockOffset.left,
                    top: e.clientY - blockOffset.top
                });

                gsap.to(thumbnails, {
                    scale: 1,
                    opacity: 1,
                    duration: fadeConfig.duration,
                    ease: fadeConfig.ease
                });
            });

            services.addEventListener("mousemove", (e) => {
                const serviceOffset = services.getBoundingClientRect();
                const xPos = (e.clientX - serviceOffset.left) / serviceOffset.width;
                const rotation = (xPos * 40) - 20;

                moveX(e.clientX - serviceOffset.left);
                moveY(e.clientY - serviceOffset.top);
                rotate(rotation);
            });

            services.addEventListener("mouseleave", () => {
                gsap.to(thumbnails, {
                    scale: 0.5,
                    opacity: 0,
                    duration: fadeConfig.duration,
                    ease: fadeConfig.ease
                });

            });
        }
    }



}